import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import ZoomEdit from "../../components/ZoomMeetings/EditZoomMeeting";


const EditZoom = () => {
  return (
    <>

    
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Zoom  </h5><Breadcrumb title="Edit Subscription " /></div>


        {/* UsersListLayer */}
        <ZoomEdit />


    </>
  );
};

export default EditZoom; 